// @flow
import React from "react"

type Props = {|
  imgSrc: string,
  imgSrcSet?: ?string,
  header: string,
  text: string,
  href?: ?string,
|}

const FullpageMessage = ({ imgSrc, imgSrcSet, header, text, href }: Props) => (
  <div className="FullPageMessage">
    <div className="FullPageMessage-centeredContainer">
      <img className="FullPageMessage-image" src={imgSrc} srcSet={imgSrcSet} />
      <span className="FullPageMessage-header spTypo-display spTypo-bold">{header}</span>
      {href ? (
        <a className="FullPageMessage-link spTypo-headline spTypo-bold" href={href}>
          {text}
        </a>
      ) : (
        <div className="FullPageMessage-text">{text}</div>
      )}
    </div>
  </div>
)

FullpageMessage.defaultProps = {
  imgSrcSet: undefined,
  href: undefined,
}

export default FullpageMessage
